

exports.__esModule = true;
exports.setStickyInstrument = undefined;

var _squid = require('squid');

/**
 * Makes billing agreement financial instrument sticky if necessary
 *
 * @param {CheckoutSession} checkoutSession
 * @return {Promise}
 */
var setStickyInstrument = exports.setStickyInstrument = function setStickyInstrument(checkoutSession) {
    if (!checkoutSession) {
        throw new TypeError('missing checkoutSession');
    }

    if (checkoutSession.selectedFuturePaymentInstrument) {
        // session already has a sticky instrument
        return _squid.$promise.resolve();
    }

    var stickyInstrument = checkoutSession.getSelectedStickyInstrument();

    if (stickyInstrument) {
        return checkoutSession.action('setStickyFI', {
            data: {
                instrument_id: stickyInstrument.instrument_id
            }
        });
    }

    return _squid.$promise.resolve();
};

_squid.$promise;


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/sticky.js
// module id = ./components/xo-guest-components/src/guest/sticky.js
// module chunks = 1